export default __webpack_public_path__ + "locales/sk/EmptyView.json?hash=05221c75264e8259f6eeca81ad559f04";